import {
  selectCurrentReviewType,
  selectListQuery,
  selectReviewItem,
  selectReviewPostingState,
  selectReviewsCount,
  selectReviewsList,
  selectReviewsStats,
  selectSqueeze,
} from '../selectors/reviews';

import { useAppSelector } from './redux';

export const useReviewsList = () => useAppSelector(selectReviewsList);
export const useReviewItem = () => useAppSelector(selectReviewItem);
export const useReviewPostingState = () => useAppSelector(selectReviewPostingState);
export const useCurrentReviewType = () => useAppSelector(selectCurrentReviewType);
export const useReviewsCount = () => useAppSelector(selectReviewsCount);
export const useReviewsStats = () => useAppSelector(selectReviewsStats);
export const useSqueezeItems = () => useAppSelector(selectSqueeze);
export const useListQuery = () => useAppSelector(selectListQuery);
